/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class LoginModel {
  public emailId: any;
  public password: any;
  constructor(loginRequest: any) {
    this.emailId = loginRequest.loginId || '';
    this.password = loginRequest.password || '';
  }
}
